import React, { FC } from 'react';
import { useHasMounted } from '../hooks/useHasMounted';
import { Button } from './Button';
import { Section } from './Section';

interface PageBackButtonProps {
  url?: string;
  label: string;
  onClick?: any;
}

export const PageBackButton: FC<PageBackButtonProps> = ({ url, label, onClick, ...rest }) => {
  const hasMounted = useHasMounted();

  return (
    <Section tight contained {...rest}>
      <Button url={url} variant="pill" arrowLeft onClick={onClick} key={hasMounted ? 'back-mounted' : 'back-unmounted'}>
        {label ? `Back to ${label}` : 'Back'}
      </Button>
    </Section>
  );
};
